import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { isClient } from '@mop/shared/utils/util';
import type { Timer } from '@mop/types';

export function isNumber(value: string) {
  return /^\d+$/.test(value);
}

export function removeEmptyHtmlParagraphs(html: string) {
  return html ? html.replace(/<p>&nbsp;<\/p>/gi, '') : html;
}

export function isLinux() {
  return /X11; Linux/i.test(navigator?.userAgent);
}

export function isPrerender() {
  return navigator?.userAgent?.toLowerCase().includes('prerender');
}

export function isLoading(
  state: Ref<{
    [key: string]: boolean;
  }>,
) {
  return Object.keys(state.value).some((key: string) => key !== 'loading' && state.value[key] === true);
}

let IS_PRODUCTION_BUILD_CACHE: boolean | null = null;
export function isProductionBuild(): boolean {
  if (IS_PRODUCTION_BUILD_CACHE !== null) {
    return IS_PRODUCTION_BUILD_CACHE;
  }
  IS_PRODUCTION_BUILD_CACHE = isClient
    ? window.getNuxtPayload()?.config?.public?.RUNTIME_ENVIRONMENT === constants.RUNTIME_ENVIRONMENT.PRODUCTION
    : Boolean(process.env.PUBLIC_RUNTIME_ENVIRONMENT === constants.RUNTIME_ENVIRONMENT.PRODUCTION);
  return IS_PRODUCTION_BUILD_CACHE;
}

export function throttle(callback: (...args: any[]) => void, wait = 200) {
  let timer: Timer;
  let currentTime: number;

  return function throttledCallback(...args: unknown[]) {
    if (!currentTime) {
      // eslint-disable-next-line no-useless-call
      callback.call(null, ...args);
      currentTime = Date.now();
      return;
    }

    clearTimeout(timer);
    timer = setTimeout(
      function debouncedCall() {
        if (Date.now() - currentTime >= wait) {
          // eslint-disable-next-line no-useless-call
          callback.call(null, ...args);
          currentTime = Date.now();
        }
      },
      wait - (Date.now() - currentTime),
    );
  };
}

export function removeValuesFromArray(
  array: Array<number | string | boolean>,
  ...values: Array<number | string | boolean>
) {
  if (!Array.isArray(array) || array.length === 0) {
    return;
  }
  values.forEach((value) => {
    const index: number = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
  });
}

export function removeValuesFromArrayRef(
  list: Ref<Array<number | string | boolean>>,
  ...values: Array<number | string | boolean>
) {
  removeValuesFromArray(list.value, ...values);
}

export function addValuesToArrayRef(
  list: Ref<Array<number | string | boolean>>,
  ...values: Array<number | string | boolean>
) {
  addValuesToArray(list.value, ...values);
}

export function addValuesToArray(array: Array<number | string | boolean>, ...values: Array<number | string | boolean>) {
  if (!Array.isArray(array)) {
    return;
  }
  values.forEach((value) => {
    const index: number = array.indexOf(value);
    if (index === -1) {
      array.push(value);
    }
  });
}

export function getAsyncDatatCacheId(route: RouteLocationNormalizedLoaded): string {
  return route.path + '-' + isClient;
}
